import { render, staticRenderFns } from "./MobileNotification.vue?vue&type=template&id=303b16cf&scoped=true&"
import script from "./MobileNotification.vue?vue&type=script&lang=js&"
export * from "./MobileNotification.vue?vue&type=script&lang=js&"
import style0 from "./MobileNotification.vue?vue&type=style&index=0&id=303b16cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303b16cf",
  null
  
)

export default component.exports